import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Springt bei Routenwechsel nach oben, lässt Anker-Links (#funktionen etc.) aber in Ruhe.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
